var _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "REST APIs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#ff6f3c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18c-5 0-6 2-6 6v3c0 3-1 5-4 5 3 0 4 2 4 5v3c0 4 1 6 6 6M40 18c5 0 6 2 6 6v3c0 3 1 5 4 5-3 0-4 2-4 5v3c0 4-1 6-6 6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 32,
    r: 2.6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 2.6,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32,
    r: 2.6,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestApi);
export default __webpack_public_path__ + "static/media/rest-api.6eec6538626f9b3b37f04cf57d2c7b2d.svg";
export { ForwardRef as ReactComponent };